import { on } from "@ngrx/store";
import { CentralSupportState } from "../central-support.state";
import { ReviewQuotesActions } from "./review-quotes.actions";
import { PagesStore } from "../../../pages.state";

// **************************************************************************
// HELPER: Update centralSupport state within PagesStore
// **************************************************************************

function withCentralSupport(state: PagesStore, updater: (centralSupport: CentralSupportState) => CentralSupportState): PagesStore {
    return { ...state, centralSupport: updater(state.centralSupport) };
}

// **************************************************************************
// REVIEW QUOTES REDUCER
// **************************************************************************

const load = on(ReviewQuotesActions.load, (state: PagesStore) => withCentralSupport(state, centralSupportState => ({
    ...centralSupportState,
    reviewQuotes: { ...centralSupportState.reviewQuotes, loading: true },
    error: null,
})));

const loadSuccess = on(ReviewQuotesActions.loadSuccess, (state: PagesStore, { response }) => withCentralSupport(state, centralSupportState => ({
    ...centralSupportState,
    reviewQuotes: { ...centralSupportState.reviewQuotes, quotes: response, loaded: true, loading: false },
    error: null,
})));

const invalidate = on(ReviewQuotesActions.invalidate, (state: PagesStore) => withCentralSupport(state, centralSupportState => ({
    ...centralSupportState,
    reviewQuotes: { ...centralSupportState.reviewQuotes, loaded: false },
})));

const loadFailure = on(ReviewQuotesActions.loadFailure, (state: PagesStore, { error }) => withCentralSupport(state, centralSupportState => ({
    ...centralSupportState,
    reviewQuotes: { ...centralSupportState.reviewQuotes, loading: false },
    error: { message: error },
})));

export const reviewQuotesReducer = [invalidate, load, loadSuccess, loadFailure];
